<template lang="pug">
	
	.mobile-version
		.background-wrapper(ref='bg')
			img(ref='bgImg' src='assets/images/mobile-background.jpg')
		.joey-image(ref='joey')
			img(ref='joeyImg' src='assets/images/mobile-joey.png')

		.gradient
		.mobile-content(ref='content')
			//- .logo(ref='logo')
				//- img(src="assets/images/logo-joey.png")
			.title(ref='title')
				p(ref='chapo').chapo Shoes up presents
				p(ref='title1') Joey Bada$$
				p(ref='title2') Political Mc
			splited-text(ref='splitedText' :text="translate('globals.mobile')").content-text

</template>

<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'
	import $ from 'jquery'
	import { TweenMax } from 'gsap'
	import Scrollable from '../abstracts/scrollable'
	import Background from '../components/background.vue'
	import _ from 'lodash'
	import Globals from '~utils/Globals.js'
	import FlagsOverlay from '../components/flags-overlay.vue'
	import SplitedText from '~components/splited-text.vue'

	import Gyros from '~utils/gyros.js'
	
  @Component({
		name: 'MobileVersion',
		components: { FlagsOverlay,SplitedText }
	})

	class MobileVersion extends Scrollable {

		mounted () {

			super.mounted()

			this._dom ()
		}

		init () {
			super.init()

			var tl = new TimelineMax()

			tl.fromTo(this.$refs.bg,1.4,{opacity:0,scale:1.1},{opacity:1,scale:1},0)
			tl.fromTo(this.$refs.joey,.8,{opacity:0,scale:.95},{opacity:1,scale:1},.2)
			tl.fromTo(this.$refs.title,2,{opacity:0,scale:.9},{opacity:1,scale:1},.2)
			tl.fromTo(this.$refs.chapo,1.4,{opacity:0,scale:.9},{opacity:1,scale:1},.3)
			tl.add(()=>{
				this.$refs.splitedText.animateIn()
			},.8)

			
			
			// this.tlAppear.play()
		}

		_dom () {
			
		}

		initTimeline () {
			super.initTimeline()

		}

		raf (y) {
			super.raf(y)

			const gamma1 = _.clamp(Gyros.instance.gamma*.3,-13,17)
			const gamma2 = _.clamp(Gyros.instance.gamma*.5,-15,15)
			const gamma3 = _.clamp(Gyros.instance.gamma*.1,-1,1)

			this.$refs.joeyImg.style.transform = `translate3d(${gamma1}px,0,0)`
			this.$refs.bgImg.style.transform = `scale(1.1) translate3d(${-gamma2}px,0,0)`
			this.$refs.title1.style.transform = `scale(1.1) translate3d(${-gamma3}px,0,0)`
			this.$refs.title2.style.transform = `scale(1.1) translate3d(${gamma3}px,0,0)`

		}

		_bind () {
			super._bind()
		}

		_resize () {
			super._resize()

		}

		_on () {
			super._on()
		}

		_off () {
			super._off()
		}

	}

	export default MobileVersion

</script>


<style lang="stylus">
	
	@import '../theme/utils'
	@import '../theme/variables'
	
	.mobile-version
		width 100%
		height 100vh
		background-color $COLOR_BLUE
		position relative

		.background-wrapper,
		.joey-image
			position absolute
			top 0
			left 0
			width 100%
			overflow hidden
			opacity 0

			img
				width 100%

		.background-wrapper
			z-index 30

		.joey-image
			z-index 50

		.gradient
			position absolute
			bottom 0
			left 0
			height 20vh
			width 100%
			z-index 60
			background-color $COLOR_BLUE

			&:after
				content ""
				position absolute
				width 100%
				height 40vh
				top 1px
				left 0
				transform translateY(-100%)
				background linear-gradient(to top, rgba(5,0,108,1), rgba(5,0,108,0) )

		.mobile-content
			position absolute
			z-index 70
			bottom 0
			left 0
			height 50vh
			width 100%
			display flex
			align-items center
			flex-direction column

			.logo
				max-width 200px
				position relative
				z-index 50
				opacity 0

				img
					width 100%

			.title
				opacity 0

				.chapo
					opacity 0

				p
					color #fff
					font-size em(30px)
					font-weight 900
					text-align center
					line-height em(34px,30px)

					&:nth-child(1)
						text-transform uppercase
						font-size em(10px)
						font-weight 400
						letter-spacing .2em
						margin-bottom 12px

					&:nth-child(2)
						text-transform uppercase

			.content-text
				max-width 300px
				text-align center
				margin-top 32px

				p.line
					line-height em(32px,20px)
					letter-spacing .05em
					font-weight 700
					font-size em(18px)
					color #ff2c46

</style>


// WEBPACK FOOTER //
// mobile-version.vue?6f8c933f